export default {"src":"/_next/static/media/before-ht.e33f14c9.svg","height":417,"width":514,"blurWidth":0,"blurHeight":0};